module.exports=function(scope){ return `@import ZoomAuthentication
`};


// WEBPACK FOOTER //
// ./src/resources/code/quickstart/ios/01-import.m.tpl